import type { Bonus } from '../types/offer';
export const bonuses: Bonus[] = [{
  number: '1',
  name: 'THE ARGENTINE FOOTBALL DICTIONARY',
  description: '১০০+ ধারণা, সহজ ভাষায়।',
  detail: 'আজীবনের রেফারেন্স গাইড',
  cover: 'https://cdn.magicpatterns.com/uploads/fVtGKtTTYgKXnzhf3Qhrsv/BONO-1-BANGLADESH.png'
}, {
  number: '2',
  name: "THE CAPTAIN'S WORKBOOK",
  description: 'প্রতিদিন প্রয়োগের অনুশীলন।',
  detail: '৪০+ পৃষ্ঠার ওয়ার্কশিট',
  cover: 'https://cdn.magicpatterns.com/uploads/4L7C3JuA1CRvXFozYjNsZR/BONO-2-BANGLADESH.png'
}, {
  number: '3',
  name: 'THE PRE-GAME FLOW',
  description: 'কাজ ও পড়াশোনার সাকসেস রিচুয়াল।',
  detail: '১৫টি রুটিন · ৪০% বেশি পারফরম্যান্স',
  cover: 'https://cdn.magicpatterns.com/uploads/9VmtKLJZK9VnHpbP85ec5R/BONO-3-BANGLADESH.png'
}, {
  number: '4',
  name: '50 SOUTHERN SECRETS',
  description: 'কোচ ও উদ্যোক্তাদের ৫০টি শিক্ষা।',
  detail: 'বাংলাদেশের বাস্তবতায় প্রয়োগ',
  cover: 'https://cdn.magicpatterns.com/uploads/iRwfEM3YRaw7caKmptBx2A/BONO-4-BANGLADESH.png'
}, {
  number: '5',
  name: 'THE NEGOTIATION CRIOLLA',
  description: 'শীর্ষ ১% পেশাদারদের নেগোশিয়েশন ফ্রেমওয়ার্ক।',
  detail: 'বেতন ও ক্লায়েন্ট ডিলে ব্যবহার করুন',
  cover: 'https://cdn.magicpatterns.com/uploads/6ff7hPzZKjq2fzNfHnDXB6/BONO-5-BANGHADESH.png'
}];
